module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "componentfield",
    style: (_vm.bold ? 'font-weight: bold' : '')
  }, [(_vm.get(_vm.product, 'enriched.equivalenceCheckResult.state') !== 'FAILURE') ? _c(("tablefield-" + (_vm.config.decoratorOptions.component)), {
    tag: "component",
    attrs: {
      "config": _vm.config.decoratorOptions,
      "data": _vm.data,
      "product": _vm.product
    }
  }) : _c(("tablefield-" + (_vm.config.fallback.decorator)), {
    tag: "component",
    attrs: {
      "config": _vm.config.fallback,
      "data": _vm.get(_vm.product, _vm.config.fallback.path),
      "product": _vm.product
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-799258ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldComponent.vue
// module id = 704
// module chunks = 0